// extracted by mini-css-extract-plugin
export default {"container":"YourDetails_container__M6dkL"};